/**
 * Subscription Module Constants
 */

// API URLs
export const INITIATE_SUBSCRIPTION_PAYMENT_URL = '/api/Payment/InitiateSubscriptionPayment';
export const ON_PAYMENT_INITIATED_URL = '/api/Payment/OnPaymentInitiated';
export const GET_TRANSACTION_STATUS_URL = '/api/Payment/GetTransactionStatus';

// Translation keys
export const T_KEYS = {
  // Payment Page
  PAYMENT_TITLE: 'SUBSCRIPTION.PAYMENT_TITLE',
  PAYMENT_DESCRIPTION: 'SUBSCRIPTION.PAYMENT_DESCRIPTION',
  PAYMENT_METHOD: 'SUBSCRIPTION.PAYMENT_METHOD',
  PAYMENT_DETAILS: 'SUBSCRIPTION.PAYMENT_DETAILS',
  CREDIT_CARD: 'SUBSCRIPTION.CREDIT_CARD',
  CREDIT_CARD_DESC: 'SUBSCRIPTION.CREDIT_CARD_DESC',
  APPLE_PAY: 'SUBSCRIPTION.APPLE_PAY',
  APPLE_PAY_DESC: 'SUBSCRIPTION.APPLE_PAY_DESC',
  APPLE_PAY_UNAVAILABLE: 'SUBSCRIPTION.APPLE_PAY_UNAVAILABLE',

  // Payment Status
  PROCESSING_PAYMENT: 'SUBSCRIPTION.PROCESSING_PAYMENT',
  PAYMENT_SUCCESSFUL: 'SUBSCRIPTION.PAYMENT_SUCCESSFUL',
  PAYMENT_SUCCESSFUL_DESC: 'SUBSCRIPTION.PAYMENT_SUCCESSFUL_DESC',
  PAYMENT_FAILED: 'SUBSCRIPTION.PAYMENT_FAILED',
  PAYMENT_FAILED_DESC: 'SUBSCRIPTION.PAYMENT_FAILED_DESC',
  RETRY_PAYMENT: 'SUBSCRIPTION.RETRY_PAYMENT',
  VERIFYING_PAYMENT: 'SUBSCRIPTION.VERIFYING_PAYMENT',
  VERIFYING_PAYMENT_DESC: 'SUBSCRIPTION.VERIFYING_PAYMENT_DESC',
  PAYMENT_TIMEOUT: 'SUBSCRIPTION.PAYMENT_TIMEOUT',
  PAYMENT_TIMEOUT_DESC: 'SUBSCRIPTION.PAYMENT_TIMEOUT_DESC',

  // Actions
  SUBSCRIBE_NOW: 'SUBSCRIPTION.SUBSCRIBE_NOW',
  MANAGE_SUBSCRIPTIONS: 'SUBSCRIPTION.MANAGE_SUBSCRIPTIONS',
  GO_HOME: 'SUBSCRIPTION.GO_HOME',
  BACK: 'SUBSCRIPTION.BACK',
  TRY_AGAIN: 'SUBSCRIPTION.TRY_AGAIN',

  // Plan & Order Summary
  ORDER_SUMMARY: 'SUBSCRIPTION.ORDER_SUMMARY',
  CHANGE_PACKAGE: 'SUBSCRIPTION.CHANGE_PACKAGE',
  TOTAL: 'SUBSCRIPTION.TOTAL',
  PLAN: 'SUBSCRIPTION.PLAN',
  SUBSCRIPTION_PLAN: 'SUBSCRIPTION.SUBSCRIPTION_PLAN',
  BILLING_PERIOD: 'SUBSCRIPTION.BILLING_PERIOD',
  CURRENCY: 'SUBSCRIPTION.CURRENCY',
  YEARLY: 'SUBSCRIPTION.YEARLY',
  MONTHLY: 'SUBSCRIPTION.MONTHLY',

  // Form
  PAYMENT_SUBTITLE: 'SUBSCRIPTION.PAYMENT_SUBTITLE',
  CARD_DETAILS: 'SUBSCRIPTION.CARD_DETAILS',
  SECURE_PAYMENT: 'SUBSCRIPTION.SECURE_PAYMENT',
};

// Payment method IDs
export const PAYMENT_METHODS = {
  CREDIT_CARD: 1,
  APPLE_PAY: 2,
} as const;

// Transaction polling config
export const POLLING_INTERVAL_MS = 2500;
export const POLLING_TIMEOUT_MS = 30000;

// Terminal transaction statuses (stop polling on these)
export const TERMINAL_STATUSES = ['Captured', 'Failed'] as const;
